import { Keys } from "../../dom-tools/keyboard-events/Keys";
import { WhiteSpaceKeys } from "../../dom-tools/keyboard-events/WhiteSpaceKeys";
import { DefaultTextTransformer } from "./DefaultTextTransformer";

export type TextTransformerCallback = ( tke:TextEditorElementKeyEvent ) => string;


export class TextEditorElementKeyEvent
{
  key:string;
  ctrlKey:boolean;
  shiftKey:boolean;
  altKey:boolean;
  metaKey:boolean;
  textTransformer:TextTransformerCallback

  get hasText()
  {    
    return Keys.isText( this.key ) ;
  }

  get keyText()
  {
    if ( ! this.hasText )
    {
      return "";
    }

    if ( this.textTransformer )
    {
      return this.textTransformer( this );
    }

    return DefaultTextTransformer.$.transformText( this );
    
  }


  static from( e:KeyboardEvent )
  {
    let ev = new TextEditorElementKeyEvent();

    ev.key = e.key;

    ev.altKey   = e.altKey;
    ev.shiftKey = e.shiftKey;
    ev.metaKey  = e.metaKey;
    ev.ctrlKey  = e.ctrlKey;

    return ev;
  }

  
}